<template>
  <div class="row">

    <a-modal title="Brief layout: aanmaken"
             :visible="isNew && !loading"
             :confirm-loading="confirmLoading"
             @ok="handleModalSubmit"
             ok-text="Naam opslaan"
             @cancel="handleModalCancel"
             cancel-text="Annuleren"
             :maskClosable="false"
             :closable="false"
    >
      <p>Geef de brief layout een naam.</p>
      <a-form layout="inline">
        <a-input
            name="name"
            type="text"
            placeholder="Naam"
            v-model="name"
            :class="errors.length && !hasValidName ? 'has-error' : ''"
            @change="clearErrors()"
            :autofocus="true"
        />
      </a-form>
        <p v-if="errors.length > 0" style="padding-top: 1em">
          <span v-for="error in errors" class="errors">{{ error }}</span>
        </p>
    </a-modal>

    <div class="col-lg-9 col-md-8 col-sm-12">
      <div class="preview">

        <Skeleton v-if="loading"
                  class="skeleton"
                  v-bind:style="{
                    width: page.width + 'mm',
                    height: page.height + 'mm',
                    display: 'inline-block',
                  }"
        />

        <div class="preview-content"
             v-else
             v-bind:style="{ 'background-image': backgroundImage}"
             style="background-size: cover;background-position: top left;"
        >
          <div id="page-margin-top"
               v-bind:style="{
                 'background-color': color.pageMargin,
                 top: 0,
                 left: 0,
                 height: pageMargins.top + 'mm',
                 width: page.width + 'mm'
               }"
          ></div>

          <div id="page-margin-bottom"
               :style="{
                 'background-color': color.pageMargin,
                 top: (page.height - pageMargins.bottom) + 'mm',
                 left: 0,
                 height: pageMargins.bottom + 'mm',
                 width: page.width + 'mm',
               }"
          ></div>

          <div id="address"
               :style="{
                 'background-color': color.address,
                 top: address.top + 'mm',
                 left: address.left + 'mm',
                 height: address.height + 'mm',
                 width: address.width + 'mm',
               }"
          >
            Adres
          </div>

          <div id="timestamp"
               :style="{
                 'background-color': color.timestamp,
                 top: timestamp.top + 'mm',
                 left: timestamp.left + 'mm',
                 height: timestamp.height + 'mm',
                 width: timestamp.width + 'mm',
               }"
          >
            Plaats, datum
          </div>

          <div id="content"
               :style="{
                 'background-color': color.content,
                 top: content.top + 'mm',
                 left: content.left + 'mm',
                 height: contentHeight + 'mm',
                 width: content.width + 'mm',
               }"
          >
            Inhoud
          </div>

        </div>
      </div>
    </div>

    <div class="col-lg-3 col-md-4 col-sm-12">
      <div v-if="loading">
        <a-row type="flex" v-for="n in 11" style="margin: 0.5em 0 1em 0;" :key="n">
          <a-col flex="auto">
            <Skeleton class="skeleton skeleton-form-item" />
          </a-col>
        </a-row>
        <a-row type="flex" style="margin: 0.5em 0 1em 0;">
          <a-col flex="auto">
            <Skeleton class="skeleton skeleton-button" />
          </a-col>
          <a-col flex="auto" style="text-align: end">
            <Skeleton class="skeleton skeleton-button" :loading="true" />
          </a-col>
        </a-row>
      </div>

      <div v-else>
        <h4 :style="{'background-color': color.name, color: 'white'}" class="h4-custom">Brief layout naam</h4>

        <a-row type="flex" style="margin: 0.5em 0 1em 0;">
          <a-col flex="auto">
            <a-form layout="inline">
              <a-input
                  name="name"
                  type="text"
                  placeholder="Naam"
                  v-model="name"
                  :disabled="!editModus"
                  :class="errors.length && !hasValidName ? 'has-error' : ''"
              />
            </a-form>
          </a-col>
        </a-row>

        <h4 :style="{'background-color': color.name, color: 'white'}" class="h4-custom">Briefpapier uploaden</h4>

        <a-row type="flex" style="margin: 0.5em 0 1em 0;">
          <a-col flex="auto">
            <input
                  type="file"
                  name="stationery"
                  ref="fileInput"
                  :multiple="false"
                  :disabled="!editModus"
                  v-on:change="handleInputChange"
                  accept="image/png, image/jpeg, image/bmp"
                  style="display: none"
              />
              <a-button :disabled="!editModus" @click="onStationeryUpload">
                <upload-icon></upload-icon> Briefpapier uploaden
              </a-button>
          </a-col>
          <a-col flex="auto" style="text-align: end">
              <a-popconfirm
                  placement="topRight"
                  :title="`Huidig briefpapier verwijderen?`"
                  ok-text="Verwijderen"
                  cancel-text="Annuleren"
                  @confirm="handleDeleteStationery"
                  :disabled="!editModus"
              >
                <a-button type="danger" v-if="hasStationery" :disabled="!editModus">
                  <delete-icon></delete-icon>
                </a-button>
              </a-popconfirm>

          </a-col>
        </a-row>

        <h4 :style="{'background-color': color.pageMargin}" class="h4-custom">Pagina marges (mm)</h4>

        <a-form layout="vertical">
          <a-row type="flex">
            <a-col flex="auto">
              <a-form-item label="Boven" class="custom-padding-bottom-0">
                <a-input-number
                    v-model="pageMargins.top"
                    :min="0"
                    :max="page.height"
                    :disabled="!editModus"
                    title="mm"
                    :class="errors.length && !hasValidPageMarginTop ? 'has-error' : ''"
                />
              </a-form-item>
            </a-col>
            <a-col flex="auto">
              <a-form-item label="Onder" class="custom-padding-bottom-0">
                <a-input-number
                    v-model="pageMargins.bottom"
                    :min="0"
                    :max="page.height"
                    :disabled="!editModus"
                    title="mm"
                    :class="errors.length && !hasValidPageMarginBottom ? 'has-error' : ''"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>

        <h4 :style="{'background-color': color.address}" class="h4-custom">Adres (mm)</h4>

        <a-form layout="vertical">
          <a-row type="flex">
            <a-col flex="auto">
              <a-form-item label="Boven" class="custom-padding-bottom-0">
                <a-input-number
                    v-model="address.top"
                    :min="pageMargins.top"
                    :max="maxAddressTop"
                    :disabled="!editModus"
                    title="mm"
                    :class="errors.length && !hasValidAddressTop ? 'has-error' : ''"
                />
              </a-form-item>
            </a-col>
            <a-col flex="auto">
              <a-form-item label="Links" class="custom-padding-bottom-0">
                <a-input-number
                    v-model="address.left"
                    :min="0"
                    :max="maxAddressLeft"
                    :disabled="!editModus"
                    title="mm"
                    :class="errors.length && !hasValidAddressLeft ? 'has-error' : ''"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>

        <h4 :style="{'background-color': color.timestamp}" class="h4-custom">Plaats, datum (mm)</h4>

        <a-form layout="vertical">
          <a-row type="flex">
            <a-col flex="auto">
              <a-form-item label="Boven" class="custom-padding-bottom-0">
                <a-input-number
                    v-model="timestamp.top"
                    :min="pageMargins.top"
                    :max="maxTimestampTop"
                    :disabled="!editModus"
                    title="mm"
                    :class="errors.length && !hasValidTimestampTop ? 'has-error' : ''"
                />
              </a-form-item>
            </a-col>
            <a-col flex="auto">
              <a-form-item label="Links" class="custom-padding-bottom-0">
                <a-input-number
                    v-model="timestamp.left"
                    :min="0"
                    :max="maxTimestampLeft"
                    :disabled="!editModus"
                    title="mm"
                    :class="errors.length && !hasValidTimestampLeft ? 'has-error' : ''"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>

        <h4 :style="{'background-color': color.content}" class="h4-custom">Inhoud (mm)</h4>

        <a-form layout="vertical">
          <a-row type="flex">
            <a-col flex="auto">
              <a-form-item label="Boven" class="custom-padding-bottom-0">
                <a-input-number
                    v-model="content.top"
                    :min="pageMargins.top"
                    :max="maxContentTop"
                    :disabled="!editModus"
                    title="mm"
                    :class="errors.length && !hasValidContentTop ? 'has-error' : ''"
                />
              </a-form-item>
            </a-col>
            <a-col flex="auto">
              <a-form-item label="Links" class="custom-padding-bottom-0">
                <a-input-number
                    v-model="content.left"
                    :min="0"
                    :max="maxContentLeft"
                    :disabled="!editModus"
                    title="mm"
                    :class="errors.length && !hasValidContentLeft ? 'has-error' : ''"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row type="flex">
            <a-col flex="auto">
              <a-form-item label="Breedte" class="custom-padding-bottom-0">
                <a-input-number
                    v-model="content.width"
                    :min="0"
                    :max="maxContentWidth"
                    :disabled="!editModus"
                    title="mm"
                    :class="errors.length && !hasValidContentWidth ? 'has-error' : ''"
                    has-feedback validate-status="error"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>

        <ul v-if="errors.length > 0" style="padding-top: 1em">
          <li v-for="error in errors" class="errors">{{ error }}</li>
        </ul>

        <a-row type="flex" style="padding: 1em 0">
          <a-col flex="auto">
            <a-button @click="handleSubmit" v-if="editModus && canUpdate" type="primary" :loading="saving">
              <content-save-icon></content-save-icon>
              Opslaan
            </a-button>
            <a-button @click="handleEdit" v-else type="primary" :loading="loading" :disabled="!canUpdate">
              <pencil-icon></pencil-icon>
              Bewerken
            </a-button>
          </a-col>
          <a-col flex="auto" style="text-align: end">
            <a-popconfirm
                placement="topRight"
                :title="`Weet je zeker dat je deze layout (${this.name}) wilt verwijderen?`"
                ok-text="Verwijderen"
                cancel-text="Annuleren"
                @confirm="handleDelete"
                :disabled="!hasLetterLayoutObjectId || !canDelete"
            >
              <a-button type="danger" :disabled="!hasLetterLayoutObjectId || !canDelete" :loading="deleting">
                <delete-icon></delete-icon>
                Verwijderen
              </a-button>
            </a-popconfirm>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import letterLayoutApi from "~/api/letter_layout";
import { Skeleton } from 'vue-loading-skeleton'

export default {
  name: "LetterLayoutCreateEditOrShowComponent",

  components: {
    Skeleton,
  },

  props: {
    id: {
      type: [String, Number],
      required: false,
      default: null,
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
    canUpdate: {
      type: Boolean,
      required: true,
      default: false,
    },
    canDelete: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  mounted() {
    if (this.editable && this.canUpdate) {
      this.editModus = true;
    }

    if (this.id !== null) {
      this.loading = true

      this.getLetterLayout(this.id)
          .then(() => {
            this.name = this.letterLayout['name']

            if (this.isObjectEmpty(this.letterLayout['page_margins']) === false) {
              this.pageMargins = this.letterLayout['page_margins']
            }
            if (this.isObjectEmpty(this.letterLayout['address']) === false) {
              this.address = this.letterLayout['address']
            }
            if (this.isObjectEmpty(this.letterLayout['timestamp']) === false) {
              this.timestamp = this.letterLayout['timestamp']
            }
            if (this.isObjectEmpty(this.letterLayout['content']) === false) {
              this.content = this.letterLayout['content']
            }

            this.loading = false;
          })
          .catch((error) => {
            this.$notification['error']({
              message: 'Er ging iets mis',
              description: `Er gaat iets mis bij het ophalen van deze layout. "${error.message}"`,
            });
          })
          .finally(() => {})
    }
  },

  data() {
    return {
      loading: false,
      saving: false,
      deleting: false,
      editModus: false,
      name: '',
      errors: [],
      letterLayout: null,
      redirectToLetterLayoutOverview: '/settings/letter_layout',
      pageMargins: {
        top: 10,
        bottom: 10,
      },
      address: {
        top: 10,
        left: 10,
        height: 15,
        width: 80,
      },
      timestamp: {
        top: 30,
        left: 10,
        height: 8,
        width: 100,
      },
      content: {
        top: 40,
        left: 10,
        width: 190,
      },
      page: {
        width: 210, // static data
        height: 297, // static data
      },
      color: {
        preview: 'rgba(68, 68, 68, 1)',
        pageMargin: 'rgba(0, 0, 0, 0.2)',
        name: 'rgba(152, 174, 191, 1)',
        address: 'rgba(143, 188, 143, 0.5)',
        timestamp: 'rgba(240, 128, 128, 0.5)',
        content: 'rgba(135, 206, 250, 0.5)',
      },
      confirmLoading: false,
    }
  },

  methods: {
    getLetterLayout(id) {
      return letterLayoutApi
          .find(id, ['stationery'])
          .then((response) => {
            this.letterLayout = response.data;
          });
    },
    handleSubmit(e) {
      if (this.checkForm(e) !== true) {
        return
      }

      this.saving = true;
        letterLayoutApi
            .update(this.collectedData)
            .then(() => {
              this.$notification['success']({
                message: 'Opgeslagen',
                description: 'Wijzigingen aan de brief layout zijn opgeslagen.',
              });
              window.location = this.redirectToLetterLayoutOverview;
            })
            .catch((error) => {
              this.$notification['error']({
                message: 'Er ging iets mis',
                description: 'Het is niet gelukt om de wijzigingen aan de brief layout op te slaan.',
              });
            })
            .finally(() => {
              this.saving = false;
              this.editModus = false;
            })
    },
    handleEdit() {
      if (this.canUpdate) {
        this.editModus = true;
      }
    },
    handleDelete() {
      this.deleting = true;

      letterLayoutApi
          .delete(this.letterLayout.id)
          .then((response) => {
            this.$notification['success']({
              message: 'Verwijderd',
              description: 'Brief layout is verwijderd.',
            });
            window.location = this.redirectToLetterLayoutOverview;
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.$notification['error']({
                message: 'Verwijderen niet mogelijk.',
                description: `${error.response.data.error}`,
              });
            } else {
              this.$notification['error']({
                message: 'Er ging iets mis',
                description: 'Het is niet gelukt om de de brief layout te verwijderen.',
              });
            }
          })
          .finally(() => {
            this.deleting = false;
          })
    },
    checkForm(e) {
      this.errors = []

      if (this.hasValidName === false) {
        this.errors.push('De brief layout "naam" dient tenminste 3 karakters lang te zijn.')
      }

      if (this.hasValidPageMarginTop === false) {
        this.errors.push(`Pagina marges "boven" kan min: 0 en max: ${this.page.height} zijn.`)
      }
      if (this.hasValidPageMarginBottom === false) {
        this.errors.push(`Pagina marges "onder" kan min: 0 en max: ${this.page.height} zijn.`)
      }

      if (this.hasValidAddressTop === false) {
        this.errors.push(`Adres "boven" kan min: 0 en max: ${this.page.height} zijn.`)
      }
      if (this.hasValidAddressLeft === false) {
        this.errors.push(`Adres "links" kan min: 0 en max: ${this.page.width} zijn.`)
      }

      if (this.hasValidTimestampTop === false) {
        this.errors.push(`Plaats, datum "boven" kan min: 0 en max: ${this.page.height} zijn.`)
      }
      if (this.hasValidTimestampLeft === false) {
        this.errors.push(`Plaats, datum "links" kan min: 0 en max: ${this.page.width} zijn.`)
      }

      if (this.hasValidContentTop === false) {
        this.errors.push(`Inhoud "boven" kan min: 0 en max: ${this.page.height} zijn.`)
      }
      if (this.hasValidContentLeft === false) {
        this.errors.push(`Inhoud "links" kan min: 0 en max: ${this.page.width} zijn.`)
      }
      if (this.hasValidContentWidth === false) {
        this.errors.push(`Inhoud "breedte" kan min: 0 en max: ${this.page.width} zijn.`)
      }

      if (!this.errors.length) {
        return true
      }

      e.preventDefault();
    },
    isObjectEmpty(objectName) {
      return Object.keys(objectName).length === 0 && objectName.constructor === Object;
    },
    onStationeryUpload() {
      this.$refs.fileInput.click();
    },
    handleInputChange(e) {
      const file = e.target.files[0];
      letterLayoutApi
          .storeStationery(file, this.letterLayout)
          .then(() => {
            this.getLetterLayout(this.letterLayout.id);
          })
          .catch((error) => {
            let errorMessage = error.response.status === 413
                ? 'Het bestand is te groot.'
                : 'Er ging iets fout tijdens het uploaden.';

            this.$notification['error']({
              message: 'Uploaden niet gelukt.',
              description: errorMessage,
            });
          })
    },
    handleDeleteStationery() {
      letterLayoutApi
          .destroyStationery(this.letterLayout)
          .then((response) => {
            this.$refs.fileInput.value = null;
            this.getLetterLayout(this.letterLayout.id)
          })
          .catch((error) => {})
          .finally(() => {})
    },
    handleModalSubmit(e) {
      if (this.checkModalForm(e) !== true) {
        return
      }

      this.confirmLoading = true;

      letterLayoutApi
          .store(this.collectedData)
          .then((response) => {
            this.getLetterLayout(response.data.id)
          })
          .catch((error) => {
            this.$notification['error']({
              message: 'Er ging iets mis',
              description: 'Het is niet gelukt om de de brief layout aan te maken.',
            });
          })
          .finally(() => {
            this.confirmLoading = false;
          })
    },
    handleModalCancel() {
      window.location = this.redirectToLetterLayoutOverview;
    },
    checkModalForm(e) {
      this.errors = []

      if (this.hasValidName === false) {
        this.errors.push('De brief layout "naam" dient tenminste 3 karakters lang te zijn.')
      }

      if (!this.errors.length) {
        return true
      }

      e.preventDefault();
    },
    clearErrors() {
      this.errors = []
    },
  },

  computed: {
    collectedData() {
      let collection = {
        'name': this.name,
        'page_margins': this.pageMargins,
        'address': this.address,
        'timestamp': this.timestamp,
        'content': this.content,
      }

      collection.content['height'] = this.contentHeight;

      if (this.hasLetterLayoutObjectId) {
        collection.id = this.letterLayout.id
      }

      return collection
    },
    backgroundImage() {
      if (this.hasStationery) {
        return `url(data:image/xyz;base64,${this.letterLayout.stationery.data.content}`
      }
      return '';
    },
    hasValidName() {
      return this.name.length > 2
    },
    hasValidPageMarginTop() {
      return this.pageMargins.top >= 0 && this.pageMargins.top <= this.page.height
    },
    hasValidPageMarginBottom() {
      return this.pageMargins.bottom >= 0 && this.pageMargins.bottom <= this.page.height
    },
    hasValidAddressTop() {
      return this.address.top >= this.pageMargins.top && this.address.top <= this.maxAddressTop
    },
    hasValidAddressLeft() {
      return this.address.left >= 0 && this.address.left <= this.maxAddressLeft
    },
    hasValidTimestampTop() {
      return this.timestamp.top >= this.pageMargins.top && this.timestamp.top <= this.maxTimestampTop
    },
    hasValidTimestampLeft() {
      return this.timestamp.left >= 0 && this.timestamp.left <= this.maxTimestampLeft
    },
    hasValidContentTop() {
      return this.content.top >= this.pageMargins.top && this.content.top <= this.maxContentTop
    },
    hasValidContentLeft() {
      return this.content.left >= 0 && this.content.left <= this.maxContentLeft
    },
    hasValidContentWidth() {
      return this.content.width >= 0 && this.content.width <= this.maxContentWidth
    },
    maxAddressTop() {
      return this.page.height - (this.address.height + this.pageMargins.bottom)
    },
    maxAddressLeft() {
      return this.page.width - this.address.width
    },
    maxTimestampTop() {
      return this.page.height - (this.timestamp.height + this.pageMargins.bottom)
    },
    maxTimestampLeft() {
      return this.page.width - this.timestamp.width
    },
    maxContentTop() {
      return this.page.height - (this.contentHeight + this.pageMargins.bottom)
    },
    maxContentLeft() {
      return this.page.width - this.content.width
    },
    maxContentHeight() {
      return this.page.height - (this.content.top + this.pageMargins.bottom)
    },
    maxContentWidth() {
      return this.page.width - this.content.left
    },
    contentHeight() {
      return this.page.height - (this.content.top + this.pageMargins.bottom)
    },
    hasStationery() {
      return this.letterLayout
          && 'stationery' in this.letterLayout
          && 'data' in this.letterLayout.stationery
          && 'content' in this.letterLayout.stationery.data
    },
    isNew() {
      return !this.hasLetterLayoutObjectId
    },
    hasLetterLayoutObjectId() {
      return this.letterLayout !== null && typeof this.letterLayout !== 'undefined' && 'id' in this.letterLayout && this.letterLayout.id !== null
    },
  },
}
</script>

<style scoped>
.h4-custom {
  padding: 0.4em;
  margin-bottom: 0;
}

.preview {
  background: #444;
  text-align: center;
  padding: 70px 20px;
  overflow: auto;
}

.preview-content {
  display: inline-block;
  text-align: left;
  max-width: 210mm;
  position: relative;
  font-size: 14px;
  min-height: 297mm;
  width: 210mm;
  background-size: contain;
  background: rgba(255, 255, 255, 1) no-repeat bottom;
}

#address, #timestamp, #content, #page-margin-bottom, #page-margin-top {
  position: absolute;
  max-width: 210mm;
  max-height: 297mm;
  border: dashed 1px rgba(255, 255, 255, 0.5);
}

.errors {
  color: #f5222d;
}

.has-error {
  border-color: #f5222d;
}

.skeleton-form-item {
  width: 100%;
  height: 2em;
  display: inline-block;
}

.skeleton-button {
  width: 100px;
  height: 32px;
  display: inline-block;
  border-radius: 4px;
}

</style>